import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OtaBatchListComponent } from './ota-batch-list.component';

const routes: Routes = [
  {
    path: 'Ota-batch-list',
    data: { name: 'OTA Batch', isTab: false },
    component: OtaBatchListComponent,
  },
  {
    path: 'Ota-batch-list/:uid',
    component: OtaBatchListComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchListRoutingModule {}
